<template>
	<div>
		<div class="home">Home</div>
		<router-link to="/" class="home">列表页</router-link>
	</div>
</template>

<script>
	import fastClick from 'fastclick'
	
	fastClick.attach(document.body)
	
	export default {
		name: 'WechatHeader'
	}
</script>

<style>
	.home {
		font-size: 50px;
	}
</style>